// src/features/rbac/components/RoleAbilities.tsx
import React from 'react';
import { useRoleAbilities } from '../hooks/useRoleAbilities';
import { useAbilities }     from '../hooks/useAbilities';

interface Props { roleKey: string }

export default function RoleAbilities({ roleKey }: Props) {
  const { data: all = [] }      = useAbilities();
  const abilities               = useRoleAbilities(roleKey);

  const linked = new Set(abilities.data ?? []);

  return (
    <div className="w-full bg-neutral-950 p-2">
      <ul className="space-y-1">
        {all.map((abl) => {
          const isLinked = linked.has(abl.ability_key);
          return (
            <li key={abl.id_ability} className="flex items-center px-2 py-1">
              <button
                onClick={() =>
                  abilities.save.mutate(
                    isLinked
                      ? abilities.data!.filter((k) => k !== abl.ability_key)
                      : [...(abilities.data ?? []), abl.ability_key],
                  )
                }
                disabled={abilities.save.isPending}
                className={`
                  flex h-6 w-6 items-center justify-center rounded
                  ${isLinked
                    ? 'text-red-500 hover:bg-neutral-800'
                    : 'text-green-400 hover:bg-neutral-800'}
                  ${abilities.save.isPending ? 'opacity-50 cursor-not-allowed' : ''}
                `}
              >
                {isLinked ? '–' : '+'}
              </button>
              <span className={isLinked ? 'text-neutral-200 ml-2' : 'text-neutral-600 ml-2'}>
                {abl.ability_key}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
